import React, { ComponentType } from 'react';
import { FormControlProps } from '@material-ui/core';
import classNames from 'classnames';

import { StyledFormControl, useStyles } from './FormControl.styles';

export const FormControl: ComponentType<FormControlProps> = ({ className, ...props }) => {
  const styles = useStyles();
  const { disabled } = props;

  const formControlClassNames = classNames(className, {
    [styles.disabled]: disabled,
  });

  return (
    // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
    <StyledFormControl {...props} className={formControlClassNames} />
  );
};
